import angular from 'angular';
import { dynamicSortMultiple, dynamicSort } from '@/shared/utils/dynamicSort';
angular
  .module('cxInvoicing')
  .controller('BatchSendInvoicesDialogCtrl', [
    '$q',
    '$element',
    '$filter',
    'templateHttpSvc',
    'flySvc',
    'close',
    '$http',
    '$translate',
    'appUrls',
    'dataCache',
    'method',
    'filters',
    'batchParams',
    'languages',
    'companyId',
    'dialogsSvc',
    batchSendInvoicesDialogCtrl,
  ]);

function batchSendInvoicesDialogCtrl(
  $q,
  $element,
  $filter,
  templateHttpSvc,
  flySvc,
  close,
  $http,
  $translate,
  appUrls,
  dataCache,
  method,
  filters,
  batchParams,
  languages,
  companyId,
  dialogSvc,
) {
  var vm = this;
  vm.templates = [];
  vm.template = null;
  vm.defaultTemplate = null;
  vm.collapsedLanguages = { nl: true, fr: true, en: true };
  vm.userLanguage = $translate.use().split('-')[0];
  vm.companyId = companyId;
  vm.method = method;

  vm.sendViaPeppol = method.toUpperCase() === 'PEPPOL';
  vm.sendViaEmail = method.toUpperCase() === 'EMAIL';
  vm.sendViaSendStrategy = method.toUpperCase() === 'SENDSTRATEGY';

  const company = companyId
    ? dataCache.getCompanySettings(companyId)
    : dataCache.getDefaultCompany();

  const { sendInvoiceTemplateId = null } = company || {};

  const contexts = [0, 23];

  // we only want to include the special/extra email templates when the user selected the 'send via e-mail button'. We wont allow a reminder email to be sent simulateneously with peppol
  if (vm.sendViaEmail) {
    contexts.push(1); // reminder
    contexts.push(16); // grouped reminder
    if (dataCache.showPaymentMonitoring) {
      contexts.push(2); // payment received
      contexts.push(8); // partial payment received
    }
  }

  if (languages && languages.length) {
    languages.forEach(lang => {
      vm.collapsedLanguages[lang] = false;
    });
  } else {
    vm.collapsedLanguages[vm.userLanguage] = false;
  }

  var showError = function(error) {
    vm.sending = false;
    flySvc.error(error);
  };

  if (vm.sendViaEmail || vm.sendViaSendStrategy) {
    templateHttpSvc.getTemplates().then(function(data) {
      vm.templates = data
        .filter(item => contexts.indexOf(item.context) >= 0)
        .map(item => {
          item.label = $filter('translateList')(item.id, 'template', item.name);
          item.contextLabel = $filter('translateList')(item.context, 'templatecontext');
          return item;
        })
        .sort(dynamicSortMultiple('context', 'label'));
      vm.defaultTemplate = sendInvoiceTemplateId
        ? vm.templates.find(x => x.id === sendInvoiceTemplateId) || null
        : null;
      vm.template = null;
      vm.refreshPreview();
    });
  }

  vm.refreshPreview = function() {
    const previewTemplate = vm.template || vm.defaultTemplate;
    if (!previewTemplate || !previewTemplate.id) {
      vm.previews = null;
      return;
    }

    vm.previews = (languages && languages.length
      ? previewTemplate.languages.filter(x => languages.indexOf(x.languageCode) >= 0)
      : previewTemplate.languages
    ).sort((a, b) => {
      // Sort by user language first, then by language code
      if (a.languageCode === b.languageCode) return 0;
      if (a.languageCode === vm.userLanguage) return -1;
      if (b.languageCode === vm.userLanguage) return 1;
      return dynamicSort('languageCode')(a, b);
    });

    const withoutContent = vm.previews.filter(x => !x.content);
    if (withoutContent.length === 0) return;

    $q.all(
      withoutContent.map(x => templateHttpSvc.getContent(previewTemplate.id, x.languageCode)),
    ).then(data => {
      vm.previews = vm.previews.map(preview => {
        if (preview.content) return preview;
        var content = data.find(x => x.id === preview.id);
        return content || preview;
      });
    });
  };
  vm.toggleLanguageCollapse = function(lang) {
    vm.collapsedLanguages[lang] = !vm.collapsedLanguages[lang];
  };

  vm.save = function() {
    if (vm.sending) return;
    if ((vm.sendViaEmail || vm.sendViaSendStrategy) && vm.template && !vm.template.id) return;
    vm.sending = true;

    let endpoint = '';
    if (vm.sendViaEmail) {
      endpoint = 'batchmail';
    } else if (vm.sendViaPeppol) {
      endpoint = 'batchsendviapeppol';
    } else if (vm.sendViaSendStrategy) {
      endpoint = 'batchsendviasendstrategy';
    }

    const sendEmails = () => {
      $http
        .post(
          `${appUrls.api}/api/invoice/${endpoint}`,
          {
            ...batchParams,
            templateId: vm.template ? vm.template.id : null,
          },
          { params: filters },
        )
        .then(() => {
          vm.sending = false;
          $element.modal('hide');
          close(true, 500);
        }, showError);
    };

    $http
      .post(
        `${appUrls.api}/api/invoice/BatchHasSentInvoices`,
        { ...batchParams },
        { params: filters },
      )
      .then(({ data }) => {
        const hasSentEmails = !!data;

        if (!hasSentEmails) {
          sendEmails();
        } else {
          $element.modal('hide');
          dialogSvc
            .showOkCancel('WarningTitle', 'msgOneOfInvoicesAlreadySent')
            .then(sendEmails, () => {
              vm.sending = false;
            });
        }
      }, showError);
  };

  vm.cancel = function() {
    close(false, 500);
  };
}
